module.exports = __webpack_public_path__ + "img/fashion_107.0fdedd5b.jpg";